import { useLayoutEffect, useState } from "react";

const VIEWPORT_MARGIN = 20;

export const usePopoverPosition = (open, anchorRef, popoverRef) => {
    const [left, setLeft] = useState(0);

    useLayoutEffect(() => {
        if (!open) return;

        const place = () => {
            const anchor = anchorRef.current;
            const popover = popoverRef.current;
            if (!anchor || !popover) return;

            const anchorLeft = anchor.getBoundingClientRect().left;
            const available = document.documentElement.clientWidth;
            const maxLeft =
                available - VIEWPORT_MARGIN - popover.offsetWidth - anchorLeft;
            const minLeft = VIEWPORT_MARGIN - anchorLeft;

            setLeft(Math.max(minLeft, Math.min(0, maxLeft)));
        };

        place();
        window.addEventListener("resize", place);
        return () => window.removeEventListener("resize", place);
    }, [open, anchorRef, popoverRef]);

    return left;
};
